import React from "react";
import { Link } from "react-router-dom";
import UploadComp from "../components/upload.com";
import { useMemo, useState } from "react";
import { UploadFile, notification, Spin } from "antd";
import axios from "axios";

interface AxiosBody {
  image_url_tag?: string;
  image_url_heel?: string;

  image_url_left?: string;
  image_url_right?: string;

  image_url_front?: string;
  image_url_bottom?: string;

  image_url_inside?: string;
  image_url_box?: string;
}

const filesDataArray = [
  {
    fileFor: "left",
    defaultImage: "./side-left.png",
    label: "Side (Left)",
    required: true,
  },
  {
    fileFor: "right",
    defaultImage: "./side-right.png",
    label: "Side (Right)",
    required: true,
  },
  {
    fileFor: "front",
    defaultImage: "./side-front.png",
    height: "80px",
    label: "Front",
    required: true,
  },
  {
    fileFor: "heel",
    defaultImage: "./side-back.png",
    label: "Back",
    required: true,
  },
  {
    fileFor: "bottom",
    defaultImage: "./side-bottom.png",
    label: "Bottom",
    height: "80px",
    required: true,
  },
  {
    fileFor: "inside",
    defaultImage: "./side-inside.png",
    label: "Inside Tongue",
    height: "80px",
    required: false,
  },
  {
    fileFor: "tag",
    defaultImage: "./side-label.png",
    label: "Tag",
    required: true,
  },
  {
    fileFor: "box",
    defaultImage: "./side-box.png",
    label: "Box",
    required: false,
  },
];

const Context = React.createContext({ name: "Default" });

export const Upload = (): JSX.Element => {
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [api, contextHolder] = notification.useNotification();
  const [loading, setLoading] = useState(false);

  const openNotification = (text: string, type: string) => {
    if (type === "info")
      api.info({
        message: "Info",
        description: text,
        placement: "topRight",
      });
    else
      api.error({
        message: "Error",
        description: text,
        placement: "topRight",
      });
  };

  const contextValue = useMemo(() => ({ name: "Ant Design" }), []);

  const handleGetReport = async () => {
    if (loading) return;
    try {
      for (let fileData of filesDataArray) {
        if (fileData.required) {
          if (
            fileList.find((file) => file.name.endsWith(`_${fileData.fileFor}`))
              ?.url === undefined
          ) {
            openNotification(
              `Upload the ${fileData.label} image to continue`,
              "error"
            );
            return;
          }
        }
      }

      setLoading(true);

      openNotification("Processing...", "info");

      const axiosBody: AxiosBody = {
        image_url_front: fileList.find((file) => file.name.endsWith("_front"))
          ?.url,
        image_url_bottom: fileList.find((file) => file.name.endsWith("_bottom"))
          ?.url,
        image_url_left: fileList.find((file) => file.name.endsWith("_left"))
          ?.url,
        image_url_right: fileList.find((file) => file.name.endsWith("_right"))
          ?.url,
        image_url_heel: fileList.find((file) => file.name.endsWith("_heel"))
          ?.url,
        image_url_tag: fileList.find((file) => file.name.endsWith("_tag"))?.url,
        image_url_box: fileList.find((file) => file.name.endsWith("_box"))?.url,
        image_url_inside: fileList.find((file) => file.name.endsWith("_inside"))
          ?.url,
      };

      // const axiosBody: AxiosBody = {
      //   image_url_bottom:
      //     "https://ws-bucket-stag.s3.amazonaws.com/public/ai_watches/1726124022221.png",
      //   image_url_front:
      //     "https://ws-bucket-stag.s3.amazonaws.com/public/ai_watches/1726123998207.png",
      //   image_url_right:
      //     "https://ws-bucket-stag.s3.amazonaws.com/public/ai_watches/1726123970459.png",
      //   image_url_left:
      //     "https://ws-bucket-stag.s3.amazonaws.com/public/ai_watches/1726123053019.png",
      //   image_url_tag:
      //     "https://ws-bucket-stag.s3.amazonaws.com/public/ai_watches/1726130923416.png",
      //   image_url_heel:
      //     "https://ws-bucket-stag.s3.amazonaws.com/public/ai_watches/1726130918860.png",
      //   image_url_box:
      //     "https://ws-cv.s3.us-east-2.amazonaws.com/sneakers/images.jpeg",
      //   image_url_inside:
      //     "https://ws-cv.s3.us-east-2.amazonaws.com/sneakers/images.jpeg",
      // };

      if (
        fileList.find((file) => file.name.endsWith("_tag"))?.url !== undefined
      ) {
        axiosBody["image_url_tag"] = fileList.find((file) =>
          file.name.endsWith("_tag")
        )?.url;
      }

      if (
        fileList.find((file) => file.name.endsWith("_heel"))?.url !== undefined
      ) {
        axiosBody["image_url_heel"] = fileList.find((file) =>
          file.name.endsWith("_heel")
        )?.url;
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/v1/grading`,
        axiosBody
      );

      // const response = await axios.post(
      //   `${process.env.REACT_APP_API_URL}/api/v1/grading`,
      //   {
      //     image_url_front: "https://wrist-shot.s3.amazonaws.com/public/ai_watches/1700394764192.png",
      //     image_url_back: "https://wrist-shot.s3.amazonaws.com/public/ai_watches/1700394764192.png",
      //     image_url_left: "https://wrist-shot.s3.amazonaws.com/public/ai_watches/1700394764192.png",
      //     image_url_right: "https://wrist-shot.s3.amazonaws.com/public/ai_watches/1700394764192.png",
      //     image_url_top: "https://wrist-shot.s3.amazonaws.com/public/ai_watches/1700394764192.png",
      //     image_url_bottom: "https://wrist-shot.s3.amazonaws.com/public/ai_watches/1700394764192.png",
      //   }
      // );

      setLoading(false);

      if (!response.data?.data?.success) {
        openNotification("Something went wrong. Try again later", "error");
        return;
      }

      const urlString = Object.entries(response.data?.data)
        .map(
          ([key, value]) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(
              JSON.stringify(value)
            )}`
        )
        .join("&");

      window.location.href = `/report/?${urlString}&image_url_heel=${encodeURIComponent(
        axiosBody.image_url_heel || ""
      )}&image_url_tag=${encodeURIComponent(
        axiosBody.image_url_tag || ""
      )}&image_url_front=${encodeURIComponent(
        axiosBody.image_url_front || ""
      )}&image_url_bottom=${encodeURIComponent(
        axiosBody.image_url_bottom || ""
      )}&image_url_left=${encodeURIComponent(
        axiosBody.image_url_left || ""
      )}&image_url_right=${encodeURIComponent(
        axiosBody.image_url_right || ""
      )}&image_url_inside=${encodeURIComponent(
        axiosBody.image_url_inside || ""
      )}&image_url_box=${encodeURIComponent(axiosBody.image_url_box || "")}`;
    } catch (error) {
      setLoading(false);
      openNotification("Something went wrong. Try again later", "error");
      throw error;
    }
  };

  return (
    <Context.Provider value={contextValue}>
      {contextHolder}
      <div className="bg-white flex flex-row justify-center w-full">
        <div className="bg-white w-[1280px] h-[832px] relative">
          <div className="absolute w-[640px] h-[832px] top-0 left-0 bg-white">
            <p className="absolute w-[566px] top-[373px] left-[40px] [font-family:'Inter-Regular',Helvetica] font-normal text-[#333333] text-[18px] tracking-[0] leading-[normal]">
              Please upload at least three well-lit photographs of your sneakers
              against a dark background, avoiding the use of flash. This will
              enhance the precision of the report.
            </p>
            <div
              className="absolute w-[83px] h-[47px] top-[745px] left-[281px] hover:cursor-pointer"
              onClick={() => {
                window.location.href = "/";
              }}
            >
              <div className="absolute top-0 left-[27px] [font-family:'Inter-Regular',Helvetica] font-normal text-[#909090] text-[14px] text-center tracking-[0] leading-[normal]">
                Exit
              </div>
              <div className="absolute top-[30px] left-0 [font-family:'Inter-Bold',Helvetica] font-bold text-[#000000] text-[14px] text-center tracking-[0] leading-[normal]">
                Need Help?
              </div>
            </div>
            <div className="absolute w-[296px] h-[157px] top-[524px] left-[172px]">
              <div className="relative w-[322px] h-[183px] top-[-9px] left-[-13px]">
                <img
                  className="w-[146px] h-[183px] top-0 left-0 absolute object-cover"
                  alt="Watch png transform"
                  src="watch-png-transform-1.png"
                />
                <img
                  className="w-[183px] h-[152px] top-[15px] left-[139px] absolute object-cover"
                  alt="Watch png transform"
                  src="watch-png-transform-2.png"
                />
              </div>
            </div>
            <div className="flex justify-left mt-12">
              <img
                className="object-contain cursor-pointer"
                alt="Sneaker Check logo black RBG"
                src="/logo.png"
                style={{ maxWidth: "120px", maxHeight: "126px" }}
                onClick={() => {
                  window.location.href = "/";
                }}
              />
            </div>
            <div className="absolute top-[309px] left-[224px] [font-family:'Inter-Bold',Helvetica] font-bold text-[#333333] text-[40px] text-center tracking-[0] leading-[normal] whitespace-nowrap">
              Add Photos
            </div>
            <img
              className="absolute w-[101px] h-[2px] top-[465px] left-[40px]"
              alt="Line"
              src="line-1.svg"
            />
          </div>

          <div className="relative w-[603px] h-[832px] top-0 left-[677px] bg-white border-l [border-left-style:solid] border-[#b4b4b4]">
            <div className="absolute top-[71px] left-[40px] [font-family:'Publico_Headline_Web-Roman',Helvetica] font-normal text-[#333333] text-[29px] tracking-[0] leading-[normal] whitespace-nowrap">
              Upload Photos
            </div>
            {/* <div className="relative w-[519px] h-[135px] top-[144px] left-[41px] bg-[#6e27c50a] rounded-[4px] border border-dashed border-[#6e27c5]">
              <p className="relative top-[51px] left-[106px] [font-family:'Inter-Bold',Helvetica] font-normal text-transparent text-[16px] tracking-[0] leading-[normal] whitespace-nowrap">
                <span className="font-bold text-[#ffb617]">Upload Photos </span>
                <span className="[font-family:'Inter-Regular',Helvetica] text-[#333333]">
                  from your computer. We need photos
                  <br />
                  of your sneakers.
                </span>
              </p>

              <div className="absolute w-[48px] h-[48px] top-[43px] left-[38px] bg-[#afafaf54] rounded-[24px]">
                <img
                  className="absolute w-[38px] h-[38px] top-[7px] left-[4px]"
                  alt="Gallery"
                  src="gallery-2-1.svg"
                />
              </div>
            </div> */}
            <div className="relative top-[171px] left-[40px]">
              <UploadComp
                fileList={fileList}
                setFileList={setFileList}
                filesDataArray={filesDataArray}
              />
            </div>
            <Link
              className="absolute w-[369px] h-[49px] top-[737px] left-[116px]"
              to="/upload"
            >
              <div className="w-[371px] h-[49px]" onClick={handleGetReport}>
                <div
                  className="relative w-[369px] h-[49px] bg-[#0053D6]"
                  style={{
                    borderRadius: "100px",
                  }}
                >
                  {loading ? (
                    <Spin className="absolute top-[16px] left-[177px]" />
                  ) : (
                    <div className="absolute top-[16px] left-[147px] [font-family:'Inter-SemiBold',Helvetica] font-semibold text-[#eeeeee] text-[14px] text-center tracking-[0] leading-[normal]">
                      Get Report
                    </div>
                  )}
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </Context.Provider>
  );
};
